export class GenericTypeEnum<T> {
	protected static Enums: Map<any, any>;

	protected constructor(public key: T, public value: string) {
	}

	public static getTypes(): Array<any> {
		if (this.Enums == null)
			this.update();

		return Array.from(this.Enums.values());
	}

	public static getMap(): Map<any, any> {
		if (this.Enums == null)
			this.update();

		return this.Enums;
	}

	public static getMapString(): Map<string, string> {
		if (this.Enums == null)
			this.update();
		let map = new Map<string, string>();
		this.Enums.forEach((value, key) => { map.set(key.toString(), value.value.toString()) });
		return map;
	}

	public static getMapNumber(): Map<number, string> {
		if (this.Enums == null)
			this.update();
		let map = new Map<number, string>();
		this.Enums.forEach((value, key) => { map.set(key, value.value.toString()) });
		return map;
	}

	public static getName(type: any): string {
		if (this.Enums == null)
			this.update();
		let item = this.Enums.get(type);
		return (item != null) ? item.value : "";
	}

	public static getType(type: any): number {
		if (this.Enums == null)
			this.update();
		return this.Enums.get(type).key;
	}

	private static update() {
		let list = Object.values(this).filter((v) => v instanceof GenericTypeEnum);
		this.Enums = new Map<any, any>(list.map(v => [v.key, v] as [any, any]));
	}
}

export enum SortType {
	Ascending = 1,
	Descending
}
export class SortEnum extends GenericTypeEnum<SortType> {
	static readonly Ascending = new SortEnum(SortType.Ascending, "asc");
	static readonly Descending = new SortEnum(SortType.Descending, "desc");
}

export enum ProviderType {
	DefaultAccount = 0,
	ActiveDirectoryAccount = 1
}
export class ProviderEnum extends GenericTypeEnum<ProviderType> {
	static readonly DefaultAccount = new ProviderEnum(ProviderType.DefaultAccount, "Padrão");
	static readonly ActiveDirectoryAccount = new ProviderEnum(ProviderType.ActiveDirectoryAccount, "AD");
}

export enum MessageType {
	Success = 0,
	Error = 1,
	Alert = 2,
	Information = 3
}
export class MessageEnum extends GenericTypeEnum<MessageType> {
	static readonly Success = new MessageEnum(MessageType.Success, "success");
	static readonly Error = new MessageEnum(MessageType.Error, "error");
	static readonly Alert = new MessageEnum(MessageType.Alert, "alert");
	static readonly Information = new MessageEnum(MessageType.Information, "information");
}

export enum MovidaRegisterType {
	New = 1,
	Edit = 2
}
export class MovidaRegisterEnum extends GenericTypeEnum<MovidaRegisterType> {
	static readonly New = new MovidaRegisterEnum(MovidaRegisterType.New, "New");
	static readonly Edit = new MovidaRegisterEnum(MovidaRegisterType.Edit, "Edit");
}